<template>
    <form
      id="redsysForm"
      name="frm"
      class="flex"
      :action="formAction"
      method="POST"
    >
      <input type="hidden" name="Ds_SignatureVersion" v-model="version" />
      <input type="hidden" name="Ds_MerchantParameters" v-model="params" />
      <input type="hidden" name="Ds_Signature" v-model="signature" />
    </form>
</template>

<script>
import { mapGetters } from "vuex";
import {
  GET_BOOKING,
  GET_BOOKING_TOTAL_PRICE,
} from "../../store/booking/getter-types";
import { SET_STEPPER_LOADING } from "../../store/stepper/action-types";
import prepareChoice from "../../utils/prepareReservation";
import moment from "../../plugins/moment";

export default {
  props: {
    gift: {
      type: Boolean,
      default: false
    },
    nights: {
      type: Boolean,
      default: false,
    },
    extras: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    version: "",
    params: "",
    signature: "",
    amount: 200,
    reservation: {},
    env: window.env,
  }),
  computed: {
    formAction() {
      if (this.env == "local")
        return "https://sis-t.redsys.es:25443/sis/realizarPago";
      else return "https://sis.redsys.es/sis/realizarPago";
    },
    ...mapGetters({
      booking: GET_BOOKING,
      totalPrice: GET_BOOKING_TOTAL_PRICE,
    }),
  },
  methods: {
    retrievePaymentParameters() {
      let choice = 'default';
      let urlParam = 'reservation'
      if (this.nights) {
        choice = 'nights';
      } else if (this.gift) {
        choice = urlParam = 'gift';
      }else if (this.extras){
        choice = urlParam = 'bonus'
      }

      axios
        .post(`/api/redsys/retrieve-parameters/${urlParam}`, {
            reservation: JSON.stringify(prepareChoice(choice)),
            gift: this.gift ? 1 : 0,
            nights: this.nights ? 1 : 0,
            extras: this.extras ? 1 : 0,
            user_timezone: moment.tz.guess()
        })
        .then((res) => {
          this.params = res.data["params"];
          this.signature = res.data["signature"];
          this.version = res.data["version"];
        })
        .then((res) => {
          //Submit redsys Form
          //Número de tarjeta: 4548812049400004
          //Caducidad: 12/20
          //Código CVV2: 123
          //Código CIP: 123456
          this.$store.dispatch(SET_STEPPER_LOADING, false);
          document.getElementById("redsysForm").submit();
        })
        .catch((err) => {
          console.log(err);
          this.$toastr.e(
            window.i18n.t('toast.error_1')
          );
          this.$store.dispatch(SET_STEPPER_LOADING, false);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.v-image {
  width: 20vw;
  max-width: 120px;
  @media (min-width: 825px) {
    width: 120px;
  }
}
</style>
